module.exports = __webpack_public_path__ + "img/hover_card_medicaid_certification.4a33eb66.svg";